cv.AdditionalInfoView = Marionette.LayoutView.extend({
  template: cv.Templates['additional_info/view'],

  events : {
  },

  regions : {
    custom_fields : '#custom-fields'
  },

  behaviors: [{
    behaviorClass: cv.FormBehavior
  }],

  validation: {
  },

  templateHelpers: function(){
    return {
    };
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    this.listenTo(this, 'form:saved', function(){
      vent.trigger('notif:success', 'Additional information has been saved.');
    }, this);

    this.listenToOnce(this.model, 'sync', function(){
      // Add the custom form field
      var customFieldsView = new cv.CustomFieldsFormView({
        values : this.model.get('custom_values'),
        type : 'user',
        container : this.$('#additional-info')
      });

      // Bind a listener
      this.listenTo(customFieldsView, 'form:saved', function(view){
        this.trigger('form:set', 'custom_values', view.getValues());
      }, this);

      // Link the custom form
      this.trigger('form:link', customFieldsView);
      this.showChildView('custom_fields', customFieldsView);
    }, this);

    console.log('AdditionalInfoView initialized.');
  },

  onAttach: function(){
    // Fetch the current data
    this.model.fetch();
  },

  onDestroy: function(){
  }
});
